import { render, staticRenderFns } from "./TemplateBildungsgang.vue?vue&type=template&id=335adc4e"
import script from "./TemplateBildungsgang.vue?vue&type=script&lang=js"
export * from "./TemplateBildungsgang.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports